<template>
  <div
    :class="{ 'video-player': true, 'hide-cursor': !showCursor }"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @mousemove="handleMouseMove"
    @touchstart="handleTouchStart"
    @touchend="handleTouchEnd"
    @touchmove="handleTouchMove"
  >
    <video
      class="video-js"
      crossorigin="anonymous"
      preload="auto"
      playsinline
      mediatype="video"
      :poster="video_poster"
      @focus="showControls = true"
      @blur="showControls = false"
      @click.prevent.stop="playPause"
      @loadedmetadata="handleVideoLoaded"
      ref="videoRef"
    ></video>
    <div
      :class="{ 'pause-overlay': true, 'd-none': !access }"
      v-if="!isPlaying && !videoEnded"
      @click.stop.prevent="playPause"
    >
      <i class="fas fa-play"></i>
    </div>

    <div
      :class="{
        'player-controller': showControls,
        'd-none': !access || !showControls,
      }"
      @keydown="handleKeyDown"
      tabindex="0"
    >
      <button
        class="btn btn-sm text-white"
        @click.stop.prevent="playPause"
      >
        <i
          class="fas"
          :class="{ 'fa-pause': isPlaying, 'fa-play': !isPlaying }"
        ></i>
      </button>
      <div class="timeline">
        <span class="start-time">
          {{ currentTime }}
        </span>
        <span class="hoved-time"> </span>
        <div
          class="progress"
          @click="handleUpdateTimeLine"
        >
          <div class="progress-bar"></div>
        </div>
        <span class="end-time">
          {{ duration }}
        </span>
      </div>
      <div class="right-controller">
        <button
          class="btn btn-sm text-white"
          @click.prevent="toggleMute"
        >
          <i
            class="fas"
            :class="{ 'fa-volume-up': !muted, 'fa-volume-mute': muted }"
          ></i>
        </button>

        <button
          class="btn btn-sm text-white"
          @click.prevent="toggleFullScreen"
          v-if="!is_small_device"
        >
          <i
            class="fas"
            :class="{
              'fa-compress': !isFullScreen,
              'fa-expand': isFullScreen,
            }"
          ></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Hls from 'hls.js';
export default {
  name: 'video_controller',
  props: {
    video_url: {
      type: String,
      required: true,
    },
    video_source: {
      type: String,
      required: true,
      default: 'cloudflare',
    },
    video_poster: {
      type: String,
      required: true,
    },
    access: {
      type: Boolean,
      required: true,
    },
    is_small_device: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      flixItem: {},
      videoRef: null,
      muted: false,
      isPlaying: false,
      showControls: true,
      showCursor: true,
      isVideoLoaded: false,
      isFullScreen: false,
      currentTime: '00:00',
      duration: `00:00`,
      availableQualities: [],
      hideControlsTimeout: null,
      callOnce: true,
      videoEnded: false,
    };
  },

  mounted() {
    this.videoRef = this.$refs.videoRef;
    this.handleLoadingVideo();
    this.isVideoLoaded = true;
    if (this.videoRef != null) {
      this.handleLoadedUpdate();
      this.videoRef.addEventListener('timeupdate', this.updateTime);

      this.videoRef.addEventListener('ended', this.handleVideoHasEnded);
      this.videoRef.addEventListener(
        'timeupdate',
        this.loadNextVideoBefore,
        false,
      );
    }
    document.addEventListener('keydown', this.handleKeyDown);

    this.autoCheckingCurseControll();
  },
  methods: {
    handlePauseSmallDevice() {
      if (this.is_small_device) {
        this.playPause();
      }
    },
    playPause() {
      if (this.access === false) {
        this.videoRef.pause();
        return;
      }

      if (this.isPlaying) {
        this.videoRef.pause();
      } else {
        this.videoRef.play();
      }
      this.isPlaying = !this.isPlaying;
    },

    toggleMute() {
      this.videoRef.muted = !this.videoRef.muted;
      this.muted = this.videoRef.muted;
    },

    autoCheckingCurseControll() {
      if (!this.videoRef.paused) {
        clearTimeout(this.hideControlsTimeout);
        this.hideControlsTimeout = setTimeout(() => {
          this.showCursor = false;
          this.showControls = false;
          this.$emit('handleCheckMoves', false);
        }, 3000);
      }
    },

    handleMouseEnter() {
      this.showControls = true;
      this.showCursor = true;
      this.$emit('handleCheckMoves', true);
    },

    handleMouseMove() {
      this.showControls = true;
      this.$emit('handleCheckMoves', true);

      clearTimeout(this.hideControlsTimeout);

      this.hideControlsTimeout = setTimeout(() => {
        if (!this.videoRef.paused) {
          this.showCursor = false;
          this.showControls = false;
          this.$emit('handleCheckMoves', false);
        }
      }, 3000);
    },
    handleTouchStart() {
      this.showControls = true;
      this.showCursor = true;
      this.$emit('handleCheckMoves', true);
    },
    handleTouchMove() {
      this.showControls = true;
      this.showCursor = true;
      this.$emit('handleCheckMoves', true);
      clearTimeout(this.hideControlsTimeout);

      this.hideControlsTimeout = setTimeout(() => {
        if (!this.videoRef.paused) {
          this.showCursor = false;
          this.showControls = false;
          this.$emit('handleCheckMoves', false);
        }
      }, 3000);
    },
    handleTouchEnd() {
      clearTimeout(this.hideControlsTimeout);
      this.hideControlsTimeout = setTimeout(() => {
        if (!this.videoRef.contains(document.activeElement)) {
          if (this.videoRef.paused) {
            this.showControls = true;
            this.$emit('handleCheckMoves', true);
          } else {
            this.showControls = false;
            this.showCursor = false;
            this.$emit('handleCheckMoves', false);
          }
        }
      }, 3000);
    },

    handleMouseLeave() {
      clearTimeout(this.hideControlsTimeout);
      this.hideControlsTimeout = setTimeout(() => {
        if (!this.videoRef.contains(document.activeElement)) {
          if (this.videoRef.paused) {
            this.showControls = true;
            this.$emit('handleCheckMoves', true);
          } else {
            this.showControls = false;
            this.showCursor = false;
            this.$emit('handleCheckMoves', false);
          }
        }
      }, 3000);
    },

    handleVideoPlay() {
      if (this.access === false) {
        this.videoRef.pause();
        return;
      }
      this.videoRef.play();
      this.isPlaying = true;
    },

    handleVideoLoaded() {
      this.isVideoLoaded = true;
    },

    toggleFullScreen() {
      if (!this.isFullScreen) {
        document.documentElement.requestFullscreen();
      } else {

        document.exitFullscreen();
      }
      this.$emit('handleFullScreen')
      this.isFullScreen = !this.isFullScreen;
    },

    updateTime() {
      const duration = this.videoRef.duration;
      const currentTime = this.videoRef.currentTime;
      this.duration = this.formatTime(duration);
      this.currentTime = this.formatTime(currentTime);

      const progress = (currentTime / duration) * 100;
      const progressElement = document.querySelector('.progress-bar');
      progressElement.style.width = `${progress}%`;
    },

    formatTime(time) {
      if (isNaN(time)) return '00:00';
      const minutes = Math.floor(time / 60);
      let seconds = Math.floor(time % 60);
      seconds = seconds > 9 ? seconds : `0${seconds}`;
      return `${minutes}:${seconds}`;
    },

    handleLoadedUpdate() {
      this.videoRef.addEventListener('loadedmetadata', this.updateTime);
    },

    skip(time) {
      this.videoRef.currentTime += time;
    },

    handleKeyDown(e) {
      const tagName = document.activeElement.tagName.toLocaleLowerCase();
      if (tagName === 'input' || tagName === 'textarea') return;
      switch (e.key.toLowerCase()) {
        case ' ':
        case 'k':
          this.playPause();
          break;
        case 'm':
          this.toggleMute();
          break;
        case 'arrowleft':
          this.skip(-5);
          break;
        case 'arrowright':
          this.skip(5);
          break;
        case 'f':
          this.toggleFullScreen();
          break;
        case 'escape':
          this.isFullScreen = false;
          break;
      }
    },

    handleLoadingVideo() {
      const videoUrl = this?.video_url;
      const isCloudflare = this?.video_source === 'cloudflare';
      this.videoRef.preload = 'metadata';

      if (isCloudflare) {
        if (Hls.isSupported()) {
          const hls = new Hls();
          hls.loadSource(videoUrl);
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            const availableQualities = hls.levels.map((l) => l.height);
            availableQualities.unshift('Auto');
            this.availableQualities = availableQualities;
          });
          let loadedBytes = 0;
          let totalBytes = 0;
          hls.on(Hls.Events.FRAG_LOADED, (event, data) => {
            loadedBytes += data.stats.loaded;
            totalBytes += data.stats.total;
            console.log(loadedBytes, totalBytes);
            const loadedPercentage = (loadedBytes / totalBytes) * 100;
            updateProgressUI(loadedPercentage);
          });
          hls.attachMedia(this.videoRef);
          this.handleVideoPlay();

          this.handleAutoPause();

          return;
        } else if (this.videoRef.canPlayType('application/vnd.apple.mpegurl')) {
          this.videoRef.src = this.video_url;

          this.videoRef.addEventListener('canplay', () => {
            if (!this.access) {
              this.videoRef.pause();
            }
            this.videoRef.play();
          });
        } else {
          this.videoRef.src = this?.video_url;
        }
      } else {
        this.videoRef.src = this?.video_url;
        this.handleVideoPlay();
      }

      this.handleAutoPause();
    },

    handleAutoPause() {
      if (!this.access) {
        this.playPause();
      } else {
        this.videoRef.play();
      }
    },

    handleVideoHasEnded() {
      this.videoEnded = true;
      this.$emit('handleVideoHasEnded');

      setTimeout(() => {
        this.videoEnded = false;
      }, 1000);
    },

    handleUpdateTimeLine(event) {
      const rect = event.target.getBoundingClientRect();
      const clickX = event.clientX - rect.left; 
      const progress = Math.min(Math.max(0, clickX), rect.width) / rect.width;
      const progressElement = document.querySelector('.progress-bar');
      const progressPercentage = progress * 100;
      progressElement.style.width = `${progressPercentage}`;
      this.videoRef.currentTime = progress * this.videoRef.duration;
    },

    updateProgressUI(loadedPercentage) {
      console.log(loadedPercentage);
      // const progressElement = document.querySelector('.progress-bar');
      // progressElement.style.width = `${loadedPercentage}%`;
    },

    loadNextVideoBefore() {
      const currentTime = this.videoRef.currentTime;
      const duration = this.videoRef.duration;
      if (currentTime >= duration - 5) {
        if (this.callOnce) {
          this.callOnce = false;
          this.$emit('handleLoadNext');
        }
      }
    },
  },
};
</script>

<style scoped>
.video-player {
  width: 100%;
  margin: 0 auto;
  height: 100%;
  position: relative;
  z-index: 2;
  display: flex;
  overflow: hidden;
  user-select: none;
}
.hide-cursor {
  cursor: none;
}


.video-player video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow-clip-margin: content-box;
  overflow: clip;
  position: absolute;
  outline: none;
  top: 0;
  left: 0;
  z-index: 2;
  &:hover {
    cursor: pointer;
  }
}
.player-controller {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  height: 52px;
  border-radius: unset;
  z-index: 3;
  justify-content: space-between;
  padding: 10px;
  align-items: center;
  display: flex;
  backdrop-filter: blur(5px);
  transition: all 0.1s;
  opacity: 1;
  transform: translateY(0);
  &:focus {
    outline: none;
  }
}

@media screen and (max-width: 768px) {
  .player-controller {
    position: fixed;
    height: 50px;
  }
}

.right-controller {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100px;
}
.timeline {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 20px;
  font-size: 12px;
}
.progress {
  width: 100%;
  margin-left: 10px;
  margin-right: 10px;
  height: 3px;
  background-color: #b1a3a3;
  position: relative;

  &:hover {
    cursor: pointer;
    height: 5px;
  }
}

.pause-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  color: rgb(0, 0, 0);
  height: 80px;
  width: 80px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}
.pause-overlay i {
  transition: all 0.1s;
  font-size: 40px;
  color: rgb(0, 0, 0, 0.8);
  &:hover {
    transform: scale(1.1);
    cursor: pointer;
  }
}
.progress-bar {
  height: 100%;
  background-color: #3b8de0;
  width: 0%;
  transition: width 0.1s;
}

:root {
  --progress-bar-color: #3b8de0;
}
</style>
